import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import {
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    project01,
    project02,
    project03,
} from '../../assets/images'
import { Link } from 'react-router-dom'

export default function ProjectGrid() {
    return (
        <>
            <Breadcrumb title="Project Grid" path="Projects / Project Grid" />
            <div className='grid xxl:grid-cols-4 md:grid-cols-2 md:gap-30 gap-15'>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
                    <img src={project01} alt='project' width="1149" height="716" className='w-full mb-15' />
                    <div className='mb-15'>
                        <Link to="/project-detail" className='inline-block text-blue text-[16px]/[19.2px] font-medium'>
                            iNext - Responsive Template
                        </Link>
                    </div>
                    <div className='text-text-secondary mb-20 line-clamp-2'>
                        <b>Lorem Ipsum is</b> simply dummy text of the printing and typesetting industry.
                    </div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden mb-20'>
                        <div className="progress-bar w-[29%] h-full bg-blue"></div>
                    </div>
                    <div className="flex items-center gap-5">
                        <p className='font-medium'>Team : </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Chris Fox' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
                    <img src={project02} alt='project' width="1149" height="716" className='w-full mb-15' />
                    <div className='mb-15'>
                        <Link to="#" className='inline-block text-blue text-[16px]/[19.2px] font-medium'>
                            Wordpress - Theme Design
                        </Link>
                    </div>
                    <div className='text-text-secondary mb-20 line-clamp-2'>
                        <b>Lorem Ipsum is</b> simply dummy text of the printing and typesetting industry.
                    </div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden mb-20'>
                        <div className="progress-bar w-[29%] h-full bg-blue"></div>
                    </div>
                    <div className="flex items-center gap-5">
                        <p className='font-medium'>Team : </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
                    <img src={project03} alt='project' width="1149" height="716" className='w-full mb-15' />
                    <div className='mb-15'>
                        <Link to="#" className='inline-block text-blue text-[16px]/[19.2px] font-medium'>
                            Logo Design
                        </Link>
                    </div>
                    <div className='text-text-secondary mb-20 line-clamp-2'>
                        <b>Lorem Ipsum is</b> simply dummy text of the printing and typesetting industry.
                    </div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden mb-20'>
                        <div className="progress-bar w-[29%] h-full bg-blue"></div>
                    </div>
                    <div className="flex items-center gap-5">
                        <p className='font-medium'>Team : </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
                    <img src={project01} alt='project' width="1149" height="716" className='w-full mb-15' />
                    <div className='mb-15'>
                        <Link to="#" className='inline-block text-blue text-[16px]/[19.2px] font-medium'>
                            iNext - Responsive Template
                        </Link>
                    </div>
                    <div className='text-text-secondary mb-20 line-clamp-2'>
                        <b>Lorem Ipsum is</b> simply dummy text of the printing and typesetting industry.
                    </div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden mb-20'>
                        <div className="progress-bar w-[29%] h-full bg-blue"></div>
                    </div>
                    <div className="flex items-center gap-5">
                        <p className='font-medium'>Team : </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Chris Fox' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar8} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar9} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
                    <img src={project02} alt='project' width="1149" height="716" className='w-full mb-15' />
                    <div className='mb-15'>
                        <Link to="#" className='inline-block text-blue text-[16px]/[19.2px] font-medium'>
                            Wordpress - Theme Design
                        </Link>
                    </div>
                    <div className='text-text-secondary mb-20 line-clamp-2'>
                        <b>Lorem Ipsum is</b> simply dummy text of the printing and typesetting industry.
                    </div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden mb-20'>
                        <div className="progress-bar w-[29%] h-full bg-blue"></div>
                    </div>
                    <div className="flex items-center gap-5">
                        <p className='font-medium'>Team : </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                            <li title='Joge Lucky' className='-ml-10 hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar7} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15'>
                    <img src={project03} alt='project' width="1149" height="716" className='w-full mb-15' />
                    <div className='mb-15'>
                        <Link to="#" className='inline-block text-blue text-[16px]/[19.2px] font-medium'>
                            Logo Design
                        </Link>
                    </div>
                    <div className='text-text-secondary mb-20 line-clamp-2'>
                        <b>Lorem Ipsum is</b> simply dummy text of the printing and typesetting industry.
                    </div>
                    <div className='progress h-5 bg-bg-light-100 rounded-sm overflow-hidden mb-20'>
                        <div className="progress-bar w-[29%] h-full bg-blue"></div>
                    </div>
                    <div className="flex items-center gap-5">
                        <p className='font-medium'>Team : </p>
                        <ul className="flex items-center">
                            <li title='Chris Fox' className='hover:translate-y-[-4px] hover:scale-[1.02] transition-all duration-300 ease-in-out'><img src={avatar6} alt="Avatar" className='w-[30px] h-[30px] rounded-full object-cover border-2 border-white shadow-medium' /></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}
